import React from "react"
import { GenericVerifiedContent } from "../generic/GenericVerifiedContent"

export const PasswordChanged = ({ handleOpenLoginDialog }) => {
  return (
    <GenericVerifiedContent
      label={'Your password has been changed successfully.'}
      handleOpenLoginDialog={handleOpenLoginDialog}
    />
  )
}